// Need to use the React-specific entry point to import createApi
import type {
  UserGroupModulePermissionSchemaResponse,
  UserGroupObjectPermissionSchemaResponse,
} from 'src/api/ProactApiClient';
import {userGroupPermissionsApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

// Define a service using a base URL and expected endpoints
export const userGroupPermissionsApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getModulePermissionSchema: builder.query<
      UserGroupModulePermissionSchemaResponse,
      void
    >({
      queryFn: clientQuery(() =>
        userGroupPermissionsApiClient.getModulePermissionSchema()
      ),
      providesTags: ['PermissionSchemas'],
    }),
    getObjectPermissionSchema: builder.query<
      UserGroupObjectPermissionSchemaResponse,
      void
    >({
      queryFn: clientQuery(() =>
        userGroupPermissionsApiClient.getObjectPermissionSchema()
      ),
      providesTags: ['PermissionSchemas'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetModulePermissionSchemaQuery,
  useGetObjectPermissionSchemaQuery,
} = userGroupPermissionsApi;
